import "core-js/modules/es.array.push.js";
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import Header from "./Header.vue";
import FristPage from "./FirstPage.vue";
import { useRouter } from "vue-router";
import { onMounted } from "vue";
export default {
  __name: 'Invite',
  setup(__props) {
    const router = useRouter();
    const jump = () => {
      router.push("/chat");
    };
    onMounted(() => {
      console.log("invite");
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(Header), _createVNode(FristPage)]);
    };
  }
};